import getReducer from '../getReducer';
import assign from 'object-assign';

import {
	PROJECT_SET_FINANCIAL_REQUEST,
	PROJECT_SET_FINANCIAL_SUCCESS,
	PROJECT_SET_FINANCIAL_FAILURE
} from '../../action/project_manager/project'
import {PROJECT_LIST_REQUEST, PROJECT_LIST_SUCCESS, PROJECT_LIST_FAILURE} from '../../action/project_manager/project'
import { POSITION_GET_ALL_REQUEST, POSITION_GET_ALL_SUCCESS, POSITION_GET_ALL_FAILURE } from '../../action/position/getall';
import { USER_GET_ALL_REQUEST, USER_GET_ALL_SUCCESS, USER_GET_ALL_FAILURE } from '../../action/user/getall';
function index(state = {
	visible: false,
	showLoading: false,
	projects: [],
}, action) {
	switch (action.type) {
			//获取项目列表
		case PROJECT_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case PROJECT_LIST_SUCCESS:
			return assign({}, state, {
				projects: action.response.result.project,
				showLoading: false
			})
		case PROJECT_LIST_FAILURE:
			return assign({}, state, {showLoading: false})

			//设置项目财务
		case PROJECT_SET_FINANCIAL_REQUEST:
			return assign({}, state, {showLoading: false})
		case PROJECT_SET_FINANCIAL_SUCCESS:
			return assign({}, state, {showLoading: true})
		case PROJECT_SET_FINANCIAL_FAILURE:
			return assign({}, state, {
				showLoading: false
			})

		//获取职位
		case POSITION_GET_ALL_REQUEST:
			return assign({}, state, {

			});
		case POSITION_GET_ALL_SUCCESS:
			return assign({}, state, {
				positions: action.response.result.positions
			});
		case POSITION_GET_ALL_FAILURE:
			return assign({}, state, {

			});
		//获取所有员工
		case USER_GET_ALL_REQUEST:
			return assign({}, state, {

			});
		case USER_GET_ALL_SUCCESS:
			return assign({}, state, {
				users: action.response.result.users
			});
		case USER_GET_ALL_FAILURE:
			return assign({}, state, {

			});
		default:
			return state;
	}
}

export default getReducer(index);


// WEBPACK FOOTER //
// ./src/reducer/financial/index.js